// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminProctoringViolationDetail_page__aYDt8 { max-width: 1600px; }

.AdminProctoringViolationDetail_backBtn__8evSY {
  display: inline-block;
  margin-bottom: 1.5rem;
  padding: 0.5rem 1rem;
  background: var(--gray-100);
  border-radius: var(--radius);
  font-size: 0.8rem;
  color: var(--gray-700);
  cursor: pointer;
  transition: all 0.2s;
}

.AdminProctoringViolationDetail_backBtn__8evSY:hover {
  background: var(--gray-200);
  transform: translateX(-3px);
}

.AdminProctoringViolationDetail_loading__BAfu5 {
  padding: 2rem;
  text-align: center;
  color: var(--gray-500);
  font-size: 0.85rem;
}

.AdminProctoringViolationDetail_error__HDxMv {
  padding: 2rem;
  text-align: center;
  color: var(--red);
  font-size: 0.85rem;
  background: var(--red-light);
  border-radius: var(--radius);
  border: 1px solid var(--red);
}

/* Candidate Header */
.AdminProctoringViolationDetail_candidateHeader__Inmc3 {
  background: white;
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 1.5rem;
  display: flex;
  align-items: center;
  gap: 1.5rem;
  margin-bottom: 1.5rem;
}

.AdminProctoringViolationDetail_candidateAvatar__tnKRp {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: var(--green-light);
  color: var(--green);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 1.5rem;
  flex-shrink: 0;
}

.AdminProctoringViolationDetail_candidateInfo__-IBZI {
  flex: 1 1;
}

.AdminProctoringViolationDetail_candidateName__hV6L2 {
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--gray-900);
  margin-bottom: 0.3rem;
}

.AdminProctoringViolationDetail_candidateMeta__2vxBL {
  display: flex;
  gap: 0.5rem;
  font-size: 0.8rem;
  color: var(--gray-600);
  align-items: center;
}

.AdminProctoringViolationDetail_email__cV6Ym { }
.AdminProctoringViolationDetail_separator__FMcwu { }
.AdminProctoringViolationDetail_role__tZpYL { }

.AdminProctoringViolationDetail_statusBadge__Be4Or {
  display: inline-block;
  padding: 0.5rem 1.25rem;
  border-radius: 20px;
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: capitalize;
  letter-spacing: 0.05em;
}

.AdminProctoringViolationDetail_statusgreen__AQU1s {
  background: #d1fae5;
  color: #047857;
}

.AdminProctoringViolationDetail_statusorange__GK16G {
  background: #fed7aa;
  color: #d97706;
}

.AdminProctoringViolationDetail_statusred__soO2B {
  background: #fee2e2;
  color: #dc2626;
}

.AdminProctoringViolationDetail_statusdarkred__ejazC {
  background: #fecaca;
  color: #991b1b;
}

/* Summary Grid */
.AdminProctoringViolationDetail_summaryGrid__0gsp8 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.AdminProctoringViolationDetail_summaryCard__r\\+\\+Gg {
  background: white;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 1.25rem;
  text-align: center;
}

.AdminProctoringViolationDetail_summaryLabel__H77-\\+ {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: capitalize;
  letter-spacing: 0.05em;
  color: var(--gray-500);
  margin-bottom: 0.6rem;
}

.AdminProctoringViolationDetail_summaryValue__RzaHf {
  font-size: 1.8rem;
  font-weight: 700;
  color: var(--red);
}

/* Section */
.AdminProctoringViolationDetail_section__d7FZA {
  background: white;
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 1.5rem;
  margin-bottom: 1.5rem;
}

.AdminProctoringViolationDetail_sectionTitle__F\\+40X {
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--gray-900);
  margin-bottom: 1.25rem;
  padding-bottom: 0.75rem;
  border-bottom: 2px solid var(--border);
}

/* Violations List */
.AdminProctoringViolationDetail_violationsGrid__sdd-W {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.75rem;
}

.AdminProctoringViolationDetail_violationItem__8um-V {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem;
  background: white;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  border-left: 4px solid var(--red);
  transition: all 0.2s;
}

.AdminProctoringViolationDetail_violationItem__8um-V:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.AdminProctoringViolationDetail_violationIcon__4vF2A {
  font-size: 1.25rem;
  flex-shrink: 0;
  min-width: 28px;
  text-align: center;
}

.AdminProctoringViolationDetail_violationContent__GSkDM {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.AdminProctoringViolationDetail_violationType__fnJCC {
  font-size: 0.85rem;
  font-weight: 700;
  color: var(--gray-900);
  margin-bottom: 0.2rem;
}

.AdminProctoringViolationDetail_violationDesc__N2FiM {
  font-size: 0.75rem;
  color: var(--gray-700);
  margin-bottom: 0.3rem;
}

.AdminProctoringViolationDetail_violationTime__Bd\\+11 {
  font-size: 0.7rem;
  color: var(--gray-500);
  font-weight: 500;
}

/* No Violations */
.AdminProctoringViolationDetail_noViolations__niu35 {
  background: var(--green-light);
  border: 2px solid var(--green);
  border-radius: var(--radius-lg);
  padding: 2rem;
  text-align: center;
}

.AdminProctoringViolationDetail_noViolationsIcon__wBIqo {
  font-size: 2.5rem;
  margin-bottom: 0.75rem;
  display: block;
}

.AdminProctoringViolationDetail_noViolationsText__SqAuh {
  font-size: 0.95rem;
  color: var(--green);
  font-weight: 600;
}

/* Violation Count Badge */
.AdminProctoringViolationDetail_violationCount__-nenl {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: var(--red);
  color: white;
  border-radius: 50%;
  font-size: 0.75rem;
  font-weight: 700;
  flex-shrink: 0;
  margin-left: 0.5rem;
}

/* Modal Overlay */
.AdminProctoringViolationDetail_modalOverlay__bm4pJ {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
}

.AdminProctoringViolationDetail_modalContent__\\+8PDj {
  background: white;
  border-radius: var(--radius-lg);
  max-width: 600px;
  width: 90%;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.AdminProctoringViolationDetail_modalHeader__UwrZY {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5rem;
  border-bottom: 1px solid var(--border);
}

.AdminProctoringViolationDetail_modalTitle__XTcDx {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 1rem;
  font-weight: 700;
  color: var(--gray-900);
}

.AdminProctoringViolationDetail_modalIcon__QoW9F {
  font-size: 1.5rem;
}

.AdminProctoringViolationDetail_modalClose__z1A-f {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: var(--gray-500);
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s;
}

.AdminProctoringViolationDetail_modalClose__z1A-f:hover {
  background: var(--gray-100);
  color: var(--gray-900);
}

.AdminProctoringViolationDetail_modalBody__YCc2z {
  flex: 1 1;
  overflow-y: auto;
  padding: 1rem;
}

.AdminProctoringViolationDetail_violationDetailItem__zlHQ4 {
  padding: 0.75rem;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  margin-bottom: 0.75rem;
  background: var(--gray-50);
}

.AdminProctoringViolationDetail_violationDetailTime__B76oL {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--red);
  margin-bottom: 0.4rem;
}

.AdminProctoringViolationDetail_violationDetailDesc__6NJat {
  font-size: 0.85rem;
  color: var(--gray-700);
  line-height: 1.4;
}

/* Actions */
.AdminProctoringViolationDetail_actions__7-3Yu {
  display: flex;
  gap: 1rem;
}

.AdminProctoringViolationDetail_actionBtn__iMpAB {
  flex: 1 1;
  padding: 0.75rem 1.5rem;
  background: var(--green);
  color: white;
  border: none;
  border-radius: var(--radius);
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.AdminProctoringViolationDetail_actionBtn__iMpAB:hover {
  background: #155a30;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(26, 92, 56, 0.2);
}

.AdminProctoringViolationDetail_noResultMessage__pq7w1 {
  flex: 1 1;
  padding: 0.75rem 1.5rem;
  background: var(--gray-100);
  color: var(--gray-600);
  border-radius: var(--radius);
  font-size: 0.85rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--gray-300);
}

@media (max-width: 768px) {
  .AdminProctoringViolationDetail_candidateHeader__Inmc3 {
    flex-direction: column;
    text-align: center;
  }

  .AdminProctoringViolationDetail_summaryGrid__0gsp8 {
    grid-template-columns: 1fr;
  }

  .AdminProctoringViolationDetail_actions__7-3Yu {
    flex-direction: column;
  }

  .AdminProctoringViolationDetail_statusBadge__Be4Or {
    order: -1;
  }

  .AdminProctoringViolationDetail_violationsGrid__sdd-W {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 600px) {
  .AdminProctoringViolationDetail_page__aYDt8 { }

  .AdminProctoringViolationDetail_candidateHeader__Inmc3 {
    padding: 1.25rem;
    gap: 1rem;
  }

  .AdminProctoringViolationDetail_candidateName__hV6L2 {
    font-size: 1.05rem;
  }

  .AdminProctoringViolationDetail_summaryCard__r\\+\\+Gg {
    padding: 1rem;
  }

  .AdminProctoringViolationDetail_summaryValue__RzaHf {
    font-size: 1.5rem;
  }

  .AdminProctoringViolationDetail_violationItem__8um-V {
    padding: 0.85rem;
  }

  .AdminProctoringViolationDetail_violationsGrid__sdd-W {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/AdminProctoringViolationDetail.module.css"],"names":[],"mappings":"AAAA,8CAAQ,iBAAiB,EAAE;;AAE3B;EACE,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;EACpB,2BAA2B;EAC3B,4BAA4B;EAC5B,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,+CAAS;AACT,mDAAa;AACb,8CAAQ;;AAER;EACE,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,4BAA4B;EAC5B,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,+BAA+B;EAC/B,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,4BAA4B;EAC5B,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,wBAAwB;EACxB,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,2BAA2B;EAC3B,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,8CAAQ;;EAER;IACE,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".page { max-width: 1600px; }\n\n.backBtn {\n  display: inline-block;\n  margin-bottom: 1.5rem;\n  padding: 0.5rem 1rem;\n  background: var(--gray-100);\n  border-radius: var(--radius);\n  font-size: 0.8rem;\n  color: var(--gray-700);\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.backBtn:hover {\n  background: var(--gray-200);\n  transform: translateX(-3px);\n}\n\n.loading {\n  padding: 2rem;\n  text-align: center;\n  color: var(--gray-500);\n  font-size: 0.85rem;\n}\n\n.error {\n  padding: 2rem;\n  text-align: center;\n  color: var(--red);\n  font-size: 0.85rem;\n  background: var(--red-light);\n  border-radius: var(--radius);\n  border: 1px solid var(--red);\n}\n\n/* Candidate Header */\n.candidateHeader {\n  background: white;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: 1.5rem;\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.candidateAvatar {\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: var(--green-light);\n  color: var(--green);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 1.5rem;\n  flex-shrink: 0;\n}\n\n.candidateInfo {\n  flex: 1;\n}\n\n.candidateName {\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: var(--gray-900);\n  margin-bottom: 0.3rem;\n}\n\n.candidateMeta {\n  display: flex;\n  gap: 0.5rem;\n  font-size: 0.8rem;\n  color: var(--gray-600);\n  align-items: center;\n}\n\n.email { }\n.separator { }\n.role { }\n\n.statusBadge {\n  display: inline-block;\n  padding: 0.5rem 1.25rem;\n  border-radius: 20px;\n  font-size: 0.78rem;\n  font-weight: 700;\n  text-transform: capitalize;\n  letter-spacing: 0.05em;\n}\n\n.statusgreen {\n  background: #d1fae5;\n  color: #047857;\n}\n\n.statusorange {\n  background: #fed7aa;\n  color: #d97706;\n}\n\n.statusred {\n  background: #fee2e2;\n  color: #dc2626;\n}\n\n.statusdarkred {\n  background: #fecaca;\n  color: #991b1b;\n}\n\n/* Summary Grid */\n.summaryGrid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.summaryCard {\n  background: white;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  padding: 1.25rem;\n  text-align: center;\n}\n\n.summaryLabel {\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: capitalize;\n  letter-spacing: 0.05em;\n  color: var(--gray-500);\n  margin-bottom: 0.6rem;\n}\n\n.summaryValue {\n  font-size: 1.8rem;\n  font-weight: 700;\n  color: var(--red);\n}\n\n/* Section */\n.section {\n  background: white;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: 1.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.sectionTitle {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--gray-900);\n  margin-bottom: 1.25rem;\n  padding-bottom: 0.75rem;\n  border-bottom: 2px solid var(--border);\n}\n\n/* Violations List */\n.violationsGrid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 0.75rem;\n}\n\n.violationItem {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem;\n  background: white;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  border-left: 4px solid var(--red);\n  transition: all 0.2s;\n}\n\n.violationItem:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n}\n\n.violationIcon {\n  font-size: 1.25rem;\n  flex-shrink: 0;\n  min-width: 28px;\n  text-align: center;\n}\n\n.violationContent {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n}\n\n.violationType {\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: var(--gray-900);\n  margin-bottom: 0.2rem;\n}\n\n.violationDesc {\n  font-size: 0.75rem;\n  color: var(--gray-700);\n  margin-bottom: 0.3rem;\n}\n\n.violationTime {\n  font-size: 0.7rem;\n  color: var(--gray-500);\n  font-weight: 500;\n}\n\n/* No Violations */\n.noViolations {\n  background: var(--green-light);\n  border: 2px solid var(--green);\n  border-radius: var(--radius-lg);\n  padding: 2rem;\n  text-align: center;\n}\n\n.noViolationsIcon {\n  font-size: 2.5rem;\n  margin-bottom: 0.75rem;\n  display: block;\n}\n\n.noViolationsText {\n  font-size: 0.95rem;\n  color: var(--green);\n  font-weight: 600;\n}\n\n/* Violation Count Badge */\n.violationCount {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  background: var(--red);\n  color: white;\n  border-radius: 50%;\n  font-size: 0.75rem;\n  font-weight: 700;\n  flex-shrink: 0;\n  margin-left: 0.5rem;\n}\n\n/* Modal Overlay */\n.modalOverlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 100;\n}\n\n.modalContent {\n  background: white;\n  border-radius: var(--radius-lg);\n  max-width: 600px;\n  width: 90%;\n  max-height: 80vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n}\n\n.modalHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.5rem;\n  border-bottom: 1px solid var(--border);\n}\n\n.modalTitle {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--gray-900);\n}\n\n.modalIcon {\n  font-size: 1.5rem;\n}\n\n.modalClose {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  color: var(--gray-500);\n  cursor: pointer;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: all 0.2s;\n}\n\n.modalClose:hover {\n  background: var(--gray-100);\n  color: var(--gray-900);\n}\n\n.modalBody {\n  flex: 1;\n  overflow-y: auto;\n  padding: 1rem;\n}\n\n.violationDetailItem {\n  padding: 0.75rem;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  margin-bottom: 0.75rem;\n  background: var(--gray-50);\n}\n\n.violationDetailTime {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--red);\n  margin-bottom: 0.4rem;\n}\n\n.violationDetailDesc {\n  font-size: 0.85rem;\n  color: var(--gray-700);\n  line-height: 1.4;\n}\n\n/* Actions */\n.actions {\n  display: flex;\n  gap: 1rem;\n}\n\n.actionBtn {\n  flex: 1;\n  padding: 0.75rem 1.5rem;\n  background: var(--green);\n  color: white;\n  border: none;\n  border-radius: var(--radius);\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.actionBtn:hover {\n  background: #155a30;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(26, 92, 56, 0.2);\n}\n\n.noResultMessage {\n  flex: 1;\n  padding: 0.75rem 1.5rem;\n  background: var(--gray-100);\n  color: var(--gray-600);\n  border-radius: var(--radius);\n  font-size: 0.85rem;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--gray-300);\n}\n\n@media (max-width: 768px) {\n  .candidateHeader {\n    flex-direction: column;\n    text-align: center;\n  }\n\n  .summaryGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .actions {\n    flex-direction: column;\n  }\n\n  .statusBadge {\n    order: -1;\n  }\n\n  .violationsGrid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 600px) {\n  .page { }\n\n  .candidateHeader {\n    padding: 1.25rem;\n    gap: 1rem;\n  }\n\n  .candidateName {\n    font-size: 1.05rem;\n  }\n\n  .summaryCard {\n    padding: 1rem;\n  }\n\n  .summaryValue {\n    font-size: 1.5rem;\n  }\n\n  .violationItem {\n    padding: 0.85rem;\n  }\n\n  .violationsGrid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `AdminProctoringViolationDetail_page__aYDt8`,
	"backBtn": `AdminProctoringViolationDetail_backBtn__8evSY`,
	"loading": `AdminProctoringViolationDetail_loading__BAfu5`,
	"error": `AdminProctoringViolationDetail_error__HDxMv`,
	"candidateHeader": `AdminProctoringViolationDetail_candidateHeader__Inmc3`,
	"candidateAvatar": `AdminProctoringViolationDetail_candidateAvatar__tnKRp`,
	"candidateInfo": `AdminProctoringViolationDetail_candidateInfo__-IBZI`,
	"candidateName": `AdminProctoringViolationDetail_candidateName__hV6L2`,
	"candidateMeta": `AdminProctoringViolationDetail_candidateMeta__2vxBL`,
	"email": `AdminProctoringViolationDetail_email__cV6Ym`,
	"separator": `AdminProctoringViolationDetail_separator__FMcwu`,
	"role": `AdminProctoringViolationDetail_role__tZpYL`,
	"statusBadge": `AdminProctoringViolationDetail_statusBadge__Be4Or`,
	"statusgreen": `AdminProctoringViolationDetail_statusgreen__AQU1s`,
	"statusorange": `AdminProctoringViolationDetail_statusorange__GK16G`,
	"statusred": `AdminProctoringViolationDetail_statusred__soO2B`,
	"statusdarkred": `AdminProctoringViolationDetail_statusdarkred__ejazC`,
	"summaryGrid": `AdminProctoringViolationDetail_summaryGrid__0gsp8`,
	"summaryCard": `AdminProctoringViolationDetail_summaryCard__r++Gg`,
	"summaryLabel": `AdminProctoringViolationDetail_summaryLabel__H77-+`,
	"summaryValue": `AdminProctoringViolationDetail_summaryValue__RzaHf`,
	"section": `AdminProctoringViolationDetail_section__d7FZA`,
	"sectionTitle": `AdminProctoringViolationDetail_sectionTitle__F+40X`,
	"violationsGrid": `AdminProctoringViolationDetail_violationsGrid__sdd-W`,
	"violationItem": `AdminProctoringViolationDetail_violationItem__8um-V`,
	"violationIcon": `AdminProctoringViolationDetail_violationIcon__4vF2A`,
	"violationContent": `AdminProctoringViolationDetail_violationContent__GSkDM`,
	"violationType": `AdminProctoringViolationDetail_violationType__fnJCC`,
	"violationDesc": `AdminProctoringViolationDetail_violationDesc__N2FiM`,
	"violationTime": `AdminProctoringViolationDetail_violationTime__Bd+11`,
	"noViolations": `AdminProctoringViolationDetail_noViolations__niu35`,
	"noViolationsIcon": `AdminProctoringViolationDetail_noViolationsIcon__wBIqo`,
	"noViolationsText": `AdminProctoringViolationDetail_noViolationsText__SqAuh`,
	"violationCount": `AdminProctoringViolationDetail_violationCount__-nenl`,
	"modalOverlay": `AdminProctoringViolationDetail_modalOverlay__bm4pJ`,
	"modalContent": `AdminProctoringViolationDetail_modalContent__+8PDj`,
	"modalHeader": `AdminProctoringViolationDetail_modalHeader__UwrZY`,
	"modalTitle": `AdminProctoringViolationDetail_modalTitle__XTcDx`,
	"modalIcon": `AdminProctoringViolationDetail_modalIcon__QoW9F`,
	"modalClose": `AdminProctoringViolationDetail_modalClose__z1A-f`,
	"modalBody": `AdminProctoringViolationDetail_modalBody__YCc2z`,
	"violationDetailItem": `AdminProctoringViolationDetail_violationDetailItem__zlHQ4`,
	"violationDetailTime": `AdminProctoringViolationDetail_violationDetailTime__B76oL`,
	"violationDetailDesc": `AdminProctoringViolationDetail_violationDetailDesc__6NJat`,
	"actions": `AdminProctoringViolationDetail_actions__7-3Yu`,
	"actionBtn": `AdminProctoringViolationDetail_actionBtn__iMpAB`,
	"noResultMessage": `AdminProctoringViolationDetail_noResultMessage__pq7w1`
};
export default ___CSS_LOADER_EXPORT___;
